/* IMPORT */
import { OWNER } from '../objects/superroot.js';
import Context from '../objects/context.js';
import { isSymbol, noop } from '../utils.js';
import { callStack } from './debugger.js';
function context(symbolOrContext, fn) {
    if (isSymbol(symbolOrContext)) {
        return OWNER.context[symbolOrContext];
    }
    else {
        const stack = callStack();
        return new Context(symbolOrContext).wrap(fn || noop, undefined, undefined, stack);
    }
}
/* EXPORT */
export default context;
